import { render } from "./QuizTrueFalse.vue?vue&type=template&id=0a5c037d"
import script from "./QuizTrueFalse.vue?vue&type=script&lang=js"
export * from "./QuizTrueFalse.vue?vue&type=script&lang=js"
script.render = render

export default script